import {
  getStoreList,
  getStaffDetail,
  changeStore,
  getOverviewInfo,
  getAccomplishInfo,
  getMonthManageInfo,
  getBazaarVisitInfo,
  getMarketInfo,
  getBazaarInfo,
  getMarketVisitList,
  getMarkeRankingList,
  getMarkeReturnRankingList,
  getMarkeQualifiedList,
  getMarkeChangeList,
  getMarkeWarningInfo,
  getDesignInfo,
  getDesignRankingList,
  getDesignReturnRankingList,
  getDesignQualifiedList,
  getDesignSignList,
  getDesignWarningInfo,
  getReturnInfo,
  getReturnCauseList,
  getReturnAreaList,
  getReturnStageList,
  getReturnWarningInfo,
  getProblemSiteCount,
  getProblemTypeCount,
  getTodoItem,
  preCustomerList,
  preVisitAllocation,
  getStaffList,
  preVisitHandover,
  storeManagerList,
  saveDispatchStrategy,
  getHolderList,
  getTodayVisitList,
  press,
  saveBatchTransfer,
  saveTransfer,
  getStationList,
  getStationStaffList,
  getJobStatus,
  saveStaffStatus,
  getDispatchStrategy,
  getCustomerList,
  getManagerList,
  saveAwaitVisit,
  getAwaitVisitList,
  saveHighTransfer,
  getCustomerInfo,
  getTimeTypes
} from '@/api/storeManager.js'

import { setTokenByKey, getToken, setToken } from '@/utils/auth'
import { Notify } from 'vant'
import { login } from '@/api/staff'
const staffDetailKey = 'store-manager_staff-detail'

const setStaffDetail = token => setTokenByKey(token, staffDetailKey)

import { SessionStorage } from '@/utils'
import { getStaffRole } from '@/api/delivery'
const session = new SessionStorage()

const state = {
  token: getToken(),
  staff_detail: '',
  station_type_id: 2,
  keep_alive_list: [],
  def_staff_role_id: session.get('def_staff_role_id') || '',
  staff_role_list: session.getObject('staff_role_list') || ''
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
    setToken(token)
  },
  SET_STAFF_DETAIL: (state, staff_detail) => {
    state.staff_detail = staff_detail
    setStaffDetail(JSON.stringify(staff_detail))
  },
  SET_STORE_LIST: (state, store_list) => {
    state.store_list = store_list
  },
  SET_KEEP_ALIVE_LIST: (state, keep_alive_list) => {
    state.keep_alive_list = keep_alive_list
  },
  SET_DEF_STAFF_ROLE_ID: (state, staff_role_id) => {
    session.set('def_staff_role_id', staff_role_id)
    state.def_staff_role_id = staff_role_id
  },
  SET_STAFF_ROLE_LIST: (state, staff_role_list) => {
    session.setObject('staff_role_list', staff_role_list)
    state.staff_role_list = staff_role_list
  }
}

const actions = {
  setToken({ state, commit }, token) {
    commit('SET_TOKEN', token)
  },
  setStaffDetail({ state, commit }, staff_detail) {
    commit('SET_TOKEN', staff_detail)
  },
  addKeepAliveItem({ state, commit }, item) {
    const keep_alive_list = state.keep_alive_list
    const set = new Set(keep_alive_list)
    set.add(item)
    commit('SET_KEEP_ALIVE_LIST', Array.from(set))
  },
  delKeepAliveItem({ state, commit }, item) {
    const keep_alive_list = state.keep_alive_list
    const set = new Set(keep_alive_list)
    set.delete(item)
    commit('SET_KEEP_ALIVE_LIST', Array.from(set))
  },
  clearKeepAliveList({ state, commit }, item) {
    commit('SET_KEEP_ALIVE_LIST', [])
  },
  async login({ state, commit, dispatch }, data) {
    try {
      const res = await login(data)
      const { staff_access_info } = res.data.data
      const token = staff_access_info.token
      dispatch('setToken', token)
      return res.data.data
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  async wxLogin({ state, commit, dispatch }, data) {
    try {
      const { staff_access_info } = await dispatch('weixin/deliveryWxLogin', data, { root: true })
      const token = staff_access_info.token
      await dispatch('setToken', token)
      return token
    } catch (error) {
      error.message && Notify({ type: 'danger', message: error.message })
      dispatch('setToken', '')
      throw error
    }
  },
  getStaffRole({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffRole(data).then(response => {
        if (response.data.data.staff_role_List.length) {
          commit('SET_STAFF_ROLE_LIST', response.data.data.staff_role_List)
        }
        if (!state.def_staff_role_id && response.data.data.staff_role_List.length) {
          commit('SET_DEF_STAFF_ROLE_ID', response.data.data.staff_role_List[0].staff_role_id)
        }
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffDetail({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffDetail(data).then(response => {
        commit('SET_STAFF_DETAIL', response.data.data.staff_info)
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 01-获取门店列表
  getStoreList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStoreList(data).then(response => {
        commit('SET_STORE_LIST', response.data.data.store_list)
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-切换当前门店
  changeStore({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      changeStore(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 工作台-01-业务数据概览
  getOverviewInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getOverviewInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-市场-01-市场数据概览
  getBazaarVisitInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getBazaarVisitInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 工作台-02-业务完成情况
  getAccomplishInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAccomplishInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-市场-02-上门数据分布
  getBazaarInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getBazaarInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 工作台-03-当月经营数据
  getMonthManageInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMonthManageInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-01-销售数据概览
  getMarketInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarketInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-02-客户经理上门数据
  getMarketVisitList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarketVisitList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-03-销售排行榜
  getMarkeRankingList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarkeRankingList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-07-退单排行
  getMarkeReturnRankingList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarkeReturnRankingList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-04-行为合格率分析
  getMarkeQualifiedList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarkeQualifiedList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-退单-01-退单数据概览
  getReturnInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getReturnInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-05-转化率周期分析
  getMarkeChangeList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarkeChangeList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-退单-02-退单原因分析
  getReturnCauseList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getReturnCauseList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-销售-06-数据警告
  getMarkeWarningInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getMarkeWarningInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-退单-03-退单面积占比
  getReturnAreaList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getReturnAreaList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-设计-01-设计数据概览
  getDesignInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-退单-04-退单阶段占比
  getReturnStageList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getReturnStageList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-设计-02-设计排行
  getDesignRankingList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignRankingList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-设计-06-退单排行
  getDesignReturnRankingList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignReturnRankingList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-设计-03-行为合格率分析
  getDesignQualifiedList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignQualifiedList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-设计-04-合同签约周期
  getDesignSignList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignSignList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-设计-05-数据警告
  getDesignWarningInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDesignWarningInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // YW-退单-05-数据警告
  getReturnWarningInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getReturnWarningInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // PM-02-工程部经理业务数据统计
  getProblemSiteCount(temp, data) {
    return new Promise((resolve, reject) => {
      getProblemSiteCount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // PM-03-工程部经理问题类型统计
  getProblemTypeCount(temp, data) {
    return new Promise((resolve, reject) => {
      getProblemTypeCount(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 工作台-04-待处理事项
  getTodoItem(temp, data) {
    return new Promise((resolve, reject) => {
      getTodoItem(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 15-预上门客户列表
  preCustomerList(temp, data) {
    return new Promise((resolve, reject) => {
      preCustomerList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // (新)P-01-(店长)分配预上门
  preVisitAllocation(temp, data) {
    return new Promise((resolve, reject) => {
      preVisitAllocation(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getStaffList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStaffList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  preVisitHandover({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      preVisitHandover(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // CM-08-门店客户经理列表
  storeManagerList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      storeManagerList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 01-派单策略提交
  saveDispatchStrategy({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveDispatchStrategy(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 03-员工持单情况列表
  getHolderList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getHolderList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 04-今天到店情况列表
  getTodayVisitList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getTodayVisitList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 11-店长批量转单
  saveBatchTransfer({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveBatchTransfer(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 05-获取服务岗位类型列表
  getStationList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStationList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 13-店长催办
  press({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      press(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 06-获取服务岗位员工列表
  getStationStaffList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getStationStaffList(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 12-店长转单
  saveTransfer({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveTransfer(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 08-员工状态列表
  getJobStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getJobStatus(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 09-提交员工状态
  saveStaffStatus({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveStaffStatus(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 14-获取门店派单策略
  getDispatchStrategy({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getDispatchStrategy(data).then(response => {
        resolve(response.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomerList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getCustomerList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getManagerList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getManagerList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveAwaitVisit({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveAwaitVisit(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getAwaitVisitList({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getAwaitVisitList(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  saveHighTransfer({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      saveHighTransfer(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getCustomerInfo({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getCustomerInfo(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  },
  getTimeTypes({ state, commit }, data) {
    return new Promise((resolve, reject) => {
      getTimeTypes(data).then(response => {
        resolve(response.data.data)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
